export const foldSPIPermissionCheckResult = pc => (a, b) => pc.allowed === true ? a(pc) : b(pc);